import PaymentUnavailable from '../../components/PaymentUnavailable';
export default function DepositPayment(){return <PaymentUnavailable context="approved booking awaiting Monnify"/>}
